/**
 * CSRF utility — DEPRECATED.
 *
 * Auth migrated from session cookies to Sanctum bearer tokens (Path B).
 * CSRF is no longer needed for token requests. These functions are kept as
 * no-op stubs so any remaining imports don't break the build; new code
 * should use `apiFetch` from './apiFetch' instead.
 *
 * Remove this file once no imports remain (search: `from '.*csrf'`).
 */

export function getCsrfToken(): string | null {
  return null;
}

export async function initializeCsrf(): Promise<boolean> {
  return true;
}

export async function fetchWithCsrf(
  url: string,
  options: RequestInit = {},
): Promise<Response> {
  // Lazy import to avoid circular dependency at module load.
  const { apiFetch } = await import('./apiFetch');
  return apiFetch(url, options);
}
